import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

interface StyledPlanCardProps {
    isRemoveCta?: boolean;
    isBlackPlan?: boolean;
    isOnePlan?: boolean;
}

export const StyledPlanCard = styled.div<StyledPlanCardProps>(({ theme, isRemoveCta, isBlackPlan }) => {
    const getBackground = () => {
        return isBlackPlan
            ? `linear-gradient(90deg, ${theme.colors[theme.colorMode].text_inverse_Highest_Emphasis} 0%,${theme.colors[theme.colorMode].text_inverse_Med_Emphasis} 100%),  ${theme.colors[theme.colorMode].secondary};`
            : `linear-gradient(90deg, ${theme.colors[theme.colorMode].text_inverse_Highest_Emphasis} 0%,${theme.colors[theme.colorMode].text_inverse_disabled} 100%), ${theme.colors[theme.colorMode].background_Button_Secondary};`;
    };

    const getBorder = () => {
        return isBlackPlan
            ? `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`
            : `1px solid ${theme.colors[theme.colorMode].primary_Sub}`;
    };

    return {
        borderRadius: theme.cornerRadius.small,
        padding: isRemoveCta ? theme.spacing.x5 : theme.spacing.x3,
        border: isRemoveCta ? getBorder() : `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
        background: isRemoveCta ? getBackground() : "transparent",
        display: "flex",
        alignItems: isRemoveCta ? "center" : "flex-start",
        justifyContent: "space-between",
        flex: !isRemoveCta ? "1 1 0" : "1",
        gap: theme.spacing.xSmall,
    };
});

export const PlanContent = styled.div(({ theme }) => ({
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.x1,
    marginLeft: theme.spacing.x1,
}));

export const PlanInfo = styled.div<{ isRemoveCta: boolean }>(({ theme, isRemoveCta }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    marginBottom: theme.spacing.x1,
    marginTop: isRemoveCta ? 0 : theme.spacing.x2,
}));

export const PlanIcon = styled(Image)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const PriceContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    width: theme.spacing.xLarge,
}));

export const BasePrice = styled(Text)({
    textDecoration: "line-through",
});

export const AddCta = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: theme.elevation[theme.colorMode].floating.boxShadow,
    width: theme.spacing.xLarge,
    height: theme.spacing.xLarge,
}));

export const AddCtaImage = styled(Image)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const RemoveCta = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "28px",
    padding: `${theme.spacing.x3} ${theme.spacing.x5}`,
    borderRadius: theme.cornerRadius.xSmall,
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const PlanText = styled(Text)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const RemoveSectionContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > *:not(:last-child)": {
        marginRight: theme.spacing.x5,
    },
}));

